module.exports = __webpack_public_path__ + "img/card-varejo-interna.e2805fcf.svg";